import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import id from './locales/id.json';

export const LANGUAGE_STORAGE_KEY = 'vetpintar-language';

const getInitialLanguage = (): string => {
  if (typeof window === 'undefined') {
    return 'id';
  }

  const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored) {
    return stored;
  }

  const browserLanguage = window.navigator.language.split('-')[0];
  return browserLanguage === 'en' ? 'en' : 'id';
};

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      id: { translation: id }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'id',
    interpolation: {
      escapeValue: false
    },
    returnObjects: true
  });

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  }
});

export default i18n;
